import { Form } from "@shared/features/form/Form";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { PanelTitle } from "@shared/ui/PanelTitle";
import { title, description } from "../../friendInvitation.data";
import { useFriendInvitationForm } from "../../hooks/useFriendInvitationForm";

export type Props = {
  onContinue: () => void;
  onSkip: () => void;
  programId: number;
};

export function FriendInvitationForm({ onContinue, onSkip, programId }: Props) {
  const { fields, form, handleSubmit } = useFriendInvitationForm({
    onSuccess: onContinue,
    programId,
  });

  const { isSubmitting, isLoading, isValid } = form.formState;

  return (
    <>
      <PanelTitle title={title} description={description} />
      <div className="flex-1 flex flex-col justify-between bg-brand-50 text-brand-800">
        <Form
          fields={fields}
          form={form}
          className="px-8 py-8 flex-1"
          innerClassName="justify-center"
          errorContainerClassName="px-8"
        />
        <ActionButtonsGroup
          onSecondaryClick={onSkip}
          onPrimaryClick={handleSubmit}
          secondaryButtonText={"Skip"}
          primaryButtonText={"Continue"}
          className="px-8 py-4 border-t border-brand-800"
          isButtonsFullWidth
          primaryButtonProps={{
            disabled: !isValid || isSubmitting || isLoading,
          }}
        />
      </div>
    </>
  );
}

export default FriendInvitationForm;
